import React, { Dispatch, SetStateAction, useState } from 'react';
import { FilterIcon } from '../../../../components/icons';
import Button from '../../../../components/button/Button';
import { Dropdown, MenuProps } from 'antd';
import CustomModal from '../../../../components/CustomModal';
import Input from '../../../../components/input/Input';

const FilterAccounts = ({
    filters,
    setFilters
}: {
    filters: {  accountNumber?: string };
    setFilters: Dispatch<
        SetStateAction<{ accountNumber?: string }>
    >;
}) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [tempFilterOptions, setTempFilterOptions] = useState<{
        accountNumber?: string;
    }>({ ...filters });

    const handleApply = () => {
        setFilters({
            ...filters,
            accountNumber: tempFilterOptions.accountNumber || ''
        });
        setDropdownVisible(false);
        setModalVisible(false);
    };

    const items = [
        {
            key: '1',
            label: (
                <p className='text-ebony text-base leading-[20px] pt-4 '>
                    Filter
                </p>
            )
        },
        {
            key: '2',
            label: (
                <div>
                    <label className='text-sm font-medium text-steelBlue  block mb-2'>
                        Account number
                    </label>

                    <Input
                        type='text'
                        value={tempFilterOptions?.accountNumber}
                        style={{ height: '40px' }}
                        placeholder='number'
                        onChange={(e) =>
                            setTempFilterOptions({
                                accountNumber: e.target.value
                            })
                        }
                    />
                </div>
            )
        },
        {
            key: '6',
            label: (
                <div className='flex justify-between py-4'>
                    <Button
                        text='Cancel'
                        onClick={() => setDropdownVisible(false)}
                        variant='secondaryOutline'
                        size='sm'
                    />
                    <div className='flex gap-[16px]'>
                        <button
                            className='text-steelBlue text-xs leading-[20px]'
                            onClick={() => {
                                setTempFilterOptions({ accountNumber: '' });
                                setDropdownVisible(false);
                            }}
                        >
                            Reset
                        </button>
                        <Button
                            text='Apply Filter'
                            onClick={handleApply}
                            size='sm'
                        />
                    </div>
                </div>
            )
        }
    ];

    const handleButtonClick = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const dropdownItems = items as MenuProps['items'];
    return (
        <>
            <div className='hidden lg:block'>
                <Dropdown
                    menu={{
                        items: dropdownItems
                    }}
                    placement='bottomRight'
                    autoAdjustOverflow={false}
                    trigger={['click']}
                    open={dropdownVisible}
                    overlayStyle={{
                        pointerEvents: 'auto'
                    }}
                    dropdownRender={(menu) => (
                        <div className='w-[375px] h-[467px]'>
                            {React.cloneElement(menu as React.ReactElement)}
                        </div>
                    )}
                >
                    <Button
                        leftIcon={<FilterIcon />}
                        text='Filter'
                        variant='secondaryOutline'
                        onClick={handleButtonClick}
                        size='sm'
                    />
                </Dropdown>
            </div>

            <div className='lg:hidden w-[100vw]'>
                <CustomModal
                    isModalOpen={modalVisible}
                    onClose={() => setModalVisible(false)}
                    hideCloseIcon
                >
                    <div className='w-[85vw] h-[45vh]'>
                        {items?.map((item) => item?.label)}
                    </div>
                </CustomModal>

                <Button
                    leftIcon={<FilterIcon />}
                    text='Filter'
                    variant='tertiary'
                    onClick={() => setModalVisible(true)}
                    size='sm'
                />
            </div>
        </>
    );
};

export default FilterAccounts;
